import { useEffect, type ReactNode } from "react";

interface ModalProps {
  open: boolean;
  title: string;
  icon?: string;
  onClose: () => void;
  children: ReactNode;
}

export default function Modal({ open, title, icon, onClose, children }: ModalProps) {
  useEffect(() => {
    if (!open) return;
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", handleEsc);
    return () => window.removeEventListener("keydown", handleEsc);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/55 p-4 animate-fade-in"
      onClick={onClose}
    >
      <div
        className="w-full max-w-lg rounded-xl bg-background-50 p-6 animate-scale-in"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-start justify-between gap-4">
          <div className="flex items-center gap-3">
            {icon && (
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-accent-100 text-accent-600">
                <i className={`${icon} text-xl`} />
              </span>
            )}
            <h3 className="font-heading text-lg font-bold text-foreground-950">
              {title}
            </h3>
          </div>
          <button
            type="button"
            aria-label="关闭"
            onClick={onClose}
            className="flex h-8 w-8 cursor-pointer items-center justify-center rounded-md text-foreground-500 transition-colors hover:bg-background-100 hover:text-foreground-900"
          >
            <i className="ri-close-line text-xl" />
          </button>
        </div>
        <div className="mt-4">{children}</div>
      </div>
    </div>
  );
}